import { useQuery } from '@tanstack/react-query';
import PromptService from '../../../services/prompt-service';
import type { PromptData } from '../../../types/agent';

const useGetPromptById = (promptSlug: string | undefined, decode: boolean) => {
  return useQuery<PromptData>({
    queryKey: ['prompt', promptSlug],
    queryFn: async () => {
      const response = decode
        ? await PromptService.getResolvedPrompt(parseInt(promptSlug!))
        : await PromptService.getPromptsById(parseInt(promptSlug!));
      return response;
    },
    enabled: !!promptSlug,
  });
};

export default useGetPromptById;
